<template>
    <span>
        <el-button type="primary" size="small" @click="dialogVisible = true">{{buttonName}}</el-button>
        <el-dialog title="产品额度有效期" :visible="dialogVisible" center :before-close="handleCloseDialog" width="30%">
            <el-form :model="form" ref="form" :rules="rules">
                <el-form-item label="有效期：" prop="expire_type">
                    <el-select size="small" v-model="form.expire_type" placeholder="请选择">
                        <el-option v-if="Acs('/expire-type/one-day')" label="1天" value="4"></el-option>
                        <el-option v-if="Acs('/expire-type/seven')" label="7天" value="1"></el-option>
                        <el-option v-if="Acs('/expire-type/one-month')" label="30天" value="2"></el-option>
                        <el-option v-if="Acs('/expire-type/one-min')" label="1分钟测试使用" value="3"></el-option>
                        <el-option v-if="Acs('/expire-type/permanent')" label="永久" value="0"></el-option>
                    </el-select>
                    <el-tooltip class="item" effect="dark" placement="right">
                        <div slot="content">
                            1天: 到期后，将会还原“永久”的额度;<br/><br/>
                            7天: 到期后，将会还原“永久”的额度;<br/><br/>
                            30天: 到期后，将会还原“永久”的额度;<br/><br/>
                            永久: 更改后直接永久生效
                        </div>
                        <i class="el-icon-info"></i>
                    </el-tooltip>
                </el-form-item>
            </el-form>
            <p style="color:red;text-align: center;" v-if="form.expire_type > 0">
                到期时间：{{expire_at}}
            </p>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCloseDialog">关闭</el-button>
                <el-button type="primary" @click="handleSubmit" :loading="loading">保存</el-button>
            </div>
        </el-dialog>
    </span>
</template>
<script>
import Config from "~/config/params";
export default {
    props:{
        buttonName:{
            type: String,
            required: true,
            default: '确定'
        },
    },
    components:{
    },
    watch: {
        'form.expire_type': {
            handler(newVal, oldVal) {
                const timestamp = Math.floor(new Date().getTime() / 1000);
                if(newVal == 1){
                    this.expire_at = Config.timestampToDateTime(timestamp + 86400 * 7);
                }else if(newVal == 2){
                    this.expire_at = Config.timestampToDateTime(timestamp + 86400 * 30);
                }else if(newVal == 3){
                    this.expire_at = Config.timestampToDateTime(timestamp + 60);
                }else if(newVal == 4){
                    this.expire_at = Config.timestampToDateTime(timestamp + 86400);
                }else{
                    this.expire_at = '';
                }
            },
            deep: true, // 深度监听，确保内部属性变化也能触发
        },
    },
    data() {
        return {
            dialogVisible:false,
            options: [],
            form: {
                expire_type:'',
            },
            rules: {
                expire_type: [{required: true, message: "请选择有效期", trigger: "change"}],
            },
            formLabelWidth: '100px',
            loading: false,
            expire_at: ''
        };
    },
    created() {
    },
    methods:{
        handleSubmit(){
            this.$refs["form"].validate(valid => {
                if (valid) {
                    this.$emit("change", this.form.expire_type);
                    this.handleCloseDialog();
                } else {
                    return false;
                }
            });
        },

        handleCloseDialog(){
            this.dialogVisible = false;
        },
    }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/dialog/temporaryLimit.vue